export function removeSlashes(str: string): string {
  return str.replace(/\//g, '');
}

export const removeExtraSlashesFromUrl = (url: string): string => url.replace(/([^:]\/)\/+/g, '$1');
